export class EditWorkTimeRangeModel {
  workTimeRangeId: number;
  startTime: Date;
  stopTime: Date;
  description: string;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/time-tracker/time-tracker-model/edit-work-time-range.model.ts